import React from "react";


const BasketItem = ({ el, deleteItem, minus, plus }) => {
    return <div className="basketItem">
        <div className="basketItem_delete_item_box">
            <button className="basketItem_delete_item" onClick={() => deleteItem(el)}>Удалить</button>
        </div>
        <div className="basketItem_inline_item basketItem_inline_item_1">
            <h2 className="basket_item_props" >Материал: {el.material}</h2>
            <h2 className="basket_item_props" >Форма: {el.format}</h2>
            <h2 className="basket_item_props" >Размер: {el.formatMM1}мм{el.formatMM2 ? ` ${el.formatMM2.toString()}мм` : ""}</h2>
            <h2 className="basket_item_props" >Толщина: {el.depth}мм</h2>
            <h2 className="basket_item_props" >Вид: {el.view}</h2>
            <h2 className="basket_item_props" >Обработка: {el.processing}</h2>
            <h2 className="basket_item_props" >Сумма: {el.sum}</h2>
        </div>
        <div className="basketItem_inline_item basketItem_inline_item_2">
            <div className="basketItem_inline_item_text">{el.sum}</div>
        </div>
        <div className="basketItem_inline_item basketItem_inline_item_3">
            <button className="basketItem_inline_item_3_btn" onClick={() => plus(el)}>▲</button>
            <div style={{margin:"5px 0"}} className="basketItem_inline_item_text">{el.number}</div>
            <button className="basketItem_inline_item_3_btn" onClick={() => minus(el)}>▼</button>
        </div>
        <div className="basketItem_inline_item basketItem_inline_item_4">
            <div>{el.sum * el.number}</div>
        </div>
    </div>

}
export default BasketItem

